import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';
import pakageJson from '../../../../package.json';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss' ,  "../../../assets/newassets/custom.css",  "../../../assets/newassets/bootstrap/css/bootstrap.min.css"]
})
export class FooterComponent implements OnInit {
  currentYear: any = new Date().getFullYear();
  newslatter: UntypedFormGroup;
  ENVIRONMENT = environment;
  // to get version from package file
  public versions:any=pakageJson.version;
  public envName:any=environment.name;

  constructor(private fb: UntypedFormBuilder ,private router: Router,private aroute: ActivatedRoute, private Api:ApiService) { }

  letterArray = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"]
  profDirectoryUrl :String = environment.directoryUrl + 'directory/hcp';
  orgDirectoryUrl :String = environment.directoryUrl + 'directory/hco'

  ngOnInit() {
     this.checkServerversion();
     this.newslatter = this.fb.group({
      news: ['', Validators.required]
    });
  }

  scrollTop(){
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  serverVersion:string;
  checkServerversion(){
    this.Api.query('actuator/info').subscribe(data=>{
      this.serverVersion=data.build.version;
    })
  }


  getvalue(value){
    // window.location.href = environment.directoryUrl +`directory/hcp/specality/all/professional?name=${value}&page=1`
  }

}
